import { TASK_COMMON_TABLE } from './table.tasks';
import { TASK_SELECT_TABLE } from './tasks/select';
import { TTableTreeModel } from './table.type';
import { TASK_EDIT_TABLE } from './tasks/edit';

export const PIPELINE_TABLE = {
  applyOptions: <T>(filterGroup: TTableTreeModel<T>): TTableTreeModel<T> => {
    return [
      TASK_COMMON_TABLE.addFooterConfig,
      TASK_COMMON_TABLE.addSortOrderToHeaderConfig,
      TASK_COMMON_TABLE.removeActionCellsInViewOnly,
      TASK_COMMON_TABLE.markLeaf,
      TASK_SELECT_TABLE.addFeatureSelect,
      TASK_EDIT_TABLE.addFeatureEdit,
      TASK_COMMON_TABLE.mergeHeaderCellWithRow,
      TASK_SELECT_TABLE.hideSingleSelectHeader,
      TASK_COMMON_TABLE.addPaddingColumn,
      PIPELINE_TABLE.updateAllSelectCells,
      TASK_EDIT_TABLE.isEditOnly,
      TASK_COMMON_TABLE.logTableModel,
    ].reduce((acc, v) => v(acc), filterGroup);
  },
  updateAllSelectCells: <T>(filterGroup: TTableTreeModel<T>): TTableTreeModel<T> => {
    return [
      TASK_SELECT_TABLE.updateRowSelectCell,
      TASK_SELECT_TABLE.updateHeaderSelectCell,
      TASK_COMMON_TABLE.logTableModel,
    ].reduce((acc, v) => v(acc), filterGroup);
  },

  addRowOperation: <T>(filterGroup: TTableTreeModel<T>): TTableTreeModel<T> => {
    return [
      TASK_COMMON_TABLE.mergeHeaderCellWithRow,
      TASK_SELECT_TABLE.unselectAll,
      TASK_SELECT_TABLE.disableAll,
      PIPELINE_TABLE.updateAllSelectCells,
      TASK_COMMON_TABLE.logTableModel,
    ].reduce((acc, v) => v(acc), filterGroup);
  },

  editRowOperation: <T>(filterGroup: TTableTreeModel<T>): TTableTreeModel<T> => {
    return [
      TASK_EDIT_TABLE.removeAddRow,
      TASK_SELECT_TABLE.unselectAll,
      TASK_SELECT_TABLE.disableAll,
      PIPELINE_TABLE.updateAllSelectCells,
      TASK_EDIT_TABLE.setNoEditsInEditMode,
      TASK_COMMON_TABLE.logTableModel,
    ].reduce((acc, v) => v(acc), filterGroup);
  },
  closeEditRowOperation: <T>(filterGroup: TTableTreeModel<T>): TTableTreeModel<T> => {
    return [TASK_SELECT_TABLE.enableAll, PIPELINE_TABLE.updateAllSelectCells, TASK_COMMON_TABLE.logTableModel].reduce(
      (acc, v) => v(acc),
      filterGroup,
    );
  },
};
